function parseInlineContent(content, options) {
  if (!options.parsesVariables) {
    return [{ type: "text", text: content }];
  }
  const parts = content.split(/\[([a-z._-]+)\]/);
  const nodes = [];
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (part === void 0) {
      continue;
    }
    if (i % 2 === 1) {
      nodes.push({
        type: "placeholder",
        attrs: {
          name: part
        }
      });
    } else if (part !== "") {
      nodes.push({
        type: "text",
        text: part
      });
    }
  }
  return nodes;
}
function parseParagraphNode(paragraph, options) {
  return {
    type: "paragraph",
    content: parseInlineContent(paragraph, options)
  };
}
function parseSingleLineContent(subject, options) {
  return {
    content: parseInlineContent(subject, options)
  };
}
function parseMultilineContent(body, options) {
  return {
    content: body.split(/[\r\n]{2,}/).map((paragraph) => parseParagraphNode(paragraph, options))
  };
}
function stringifyTextNode(node) {
  return node.text;
}
function stringifyPlaceholderNode(node, options) {
  return options.stringifyVariable(node.attrs.name);
}
function stringifyInlineNode(node, options) {
  switch (node.type) {
    case "text":
      return stringifyTextNode(node);
    case "placeholder":
      return stringifyPlaceholderNode(node, options);
    default:
      return "";
  }
}
function stringifyParagraphNode(node, options) {
  return node.content.map((node2) => stringifyInlineNode(node2, options)).join("");
}
function stringifySingleLineContent(subject, options) {
  return subject.content.map((node) => stringifyInlineNode(node, options)).join("");
}
function stringifyMultilineContent(body, options) {
  return body.content.map((node) => stringifyParagraphNode(node, options)).join("\n\n");
}
function stringifyVariableAsPlaceholder(name) {
  return `[${name}]`;
}
function stringifyVariableAsEmpty(name) {
  console.warn("Failed to stringify a missing variable:", name);
  return "";
}
function stringifyVariableAsIdentity(name) {
  return name;
}
export {
  parseMultilineContent,
  parseSingleLineContent,
  stringifyMultilineContent,
  stringifySingleLineContent,
  stringifyVariableAsEmpty,
  stringifyVariableAsIdentity,
  stringifyVariableAsPlaceholder
};
//# sourceMappingURL=plaintext.js.map
